import React from 'react'

export default function HeritageAds() {
    return (
        <div id="amzn-assoc-ad-f9aec06c-c924-470a-a495-640abb4daef3"></div>
    )
}

